"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = function (text, maxLength) {
    if (text.length > 0 && text.length > maxLength) {
        var sub = text.substring(0, maxLength - 1);
        return sub + "\u2026";
    }
    return text;
};
